import { render, staticRenderFns } from "./AddPersonToList.vue?vue&type=template&id=5beaa07c&"
import script from "./AddPersonToList.vue?vue&type=script&lang=js&"
export * from "./AddPersonToList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports